import { createTemporaryId } from "../utils/model";
import { safeObjectAssign } from "../utils/object";
import { LeadListSource } from "./LeadListSource";

export class LeadListSourceConfiguration {
  readonly id = createTemporaryId();
  readonly name: string = "";
  readonly sources: LeadListSource[] = [];

  constructor(deriveFrom?: Partial<LeadListSourceConfiguration>) {
    if (deriveFrom) {
      safeObjectAssign(this, deriveFrom);
    }

    this.sources = this.sources.map(source => new LeadListSource(source));
  }

  isDefault(configIndex: number) {
    return configIndex === 0;
  }
}